import { ConfirmBlocker } from '@cash-web/protos/squareup/franklin/blockers/confirm_blocker.pb'
import { ConfirmBlockerSupplement } from '@cash-web/protos/squareup/franklin/scenarios.pb'

import { BlockerProps } from '../..'
import { ConfirmPasscode } from './ConfirmPasscode'
import { ConfirmPayment } from './ConfirmPayment'

export interface BlockerConfirmProps extends BlockerProps {
  blocker: ConfirmBlocker
  supplement?: ConfirmBlockerSupplement
}

const SUPPORTED_TOKENS = ['CUSTOMER_PASSCODE']

export function BlockerConfirm({ blocker, supplement }: BlockerConfirmProps) {
  // Confirm passcode takes priority over regular confirm blocker
  if (blocker.instrument_token === 'CUSTOMER_PASSCODE') return <ConfirmPasscode />

  // regular confirm blocker does not have an instrument token unless passcode required like the above check
  if (blocker.explicit_confirmation || blocker.initiated_by_recipient) {
    return <ConfirmPayment blocker={blocker} supplement={supplement} />
  }

  if (!SUPPORTED_TOKENS.includes(blocker.instrument_token ?? '')) {
    throw new Error(`Unsupported instrument token for Confirm blocker: ${blocker.instrument_token}`)
  }

  return null
}
